import React, { useEffect, useState } from "react";
import "./AccountDetails.css";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  EditUserInfo,
  ResetPassword,
  getProfileData,
  validatePassword,
} from "../../redux/reducers/auth";
import {
  bluesnapSupportedCountries,
  bluesnapSupportedCurrencies,
  bluesnapSupportedData,
} from "../../assets/bluesnap/bluesnapSupport";
import moment from "moment";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
} from "reactstrap";
import {
  createPayoutMethod,
  createProfilePayout,
  updatePayoutMethod,
} from "../../redux/reducers/user";
import { ToastContainer, toast } from "react-toastify";

const AccountDetailsEdit = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { translationState } = useSelector((state) => state.user);
  const { userLanguage } = useSelector((state) => state.auth);
  const toastTranslation =
    translationState?.[0]?.translations?.toast?.[userLanguage];
  const shippingCartTranslation =
    translationState?.[0]?.translations?.shippingCart?.[userLanguage];
  const sellerHomeTranslation =
    translationState?.[0]?.translations?.sellerHome?.[userLanguage];
  const userdashboardTranslation =
    translationState?.[0]?.translations?.userDashboard?.[userLanguage];

  const {
    user: {
      firstname,
      lastname,
      email,
      dateOfBirth,
      address,
      city,
      country,
      state,
      postalCode,
      phone,
      currency,
      countryCode,
      isPayoutSetup,
      vendorId,
      vendorInfoId,
    },
    token,
    loading,
  } = useSelector((state) => state.auth);
  const { err } = useSelector((state) => state.user);
  const [
    bluesnapSupportedVendorCountries,
    setBluesnapSupportedVendorCountries,
  ] = useState(bluesnapSupportedCountries);
  const [
    bluesnapSupportedVendorCurrencies,
    setBluesnapSupportedVendorCurrencies,
  ] = useState(bluesnapSupportedCurrencies);
  const [pageContent, setPageContent] = useState({
    firstname,
    lastname,
    email,
    dateOfBirth: dateOfBirth
      ? moment(dateOfBirth).format("YYYY-MM-DD")
      : moment().subtract(18, "years").format("YYYY-MM-DD"),
    address,
    city,
    country,
    state,
    postalCode,
    phone,
    currency,
    countryCode,
    isPayoutSetup,
    vendorId,
    vendorInfoId,
    displayname: "",
    currentPassword: "",
    password: "",
    confirmPassword: "",
  });
  const [showPayout, setShowPayout] = useState(false);
  const [payoutData, setPayoutData] = useState({
    payoutType: "WIRE",
    baseCurrency: currency,
    nameOnAccount: "",
    bankAccountType: "",
    bankAccountClass: "",
    bankName: "",
    swiftBic: "",
    country: countryCode,
    state,
    address,
    zip: postalCode,
    city,
    iban: vendorInfoId?.payoutInfo?.iban || "",
  });

  const [fieldErrors, setFieldErrors] = useState({});
  const [payoutFieldErrors, setPayoutFieldErrors] = useState({});

  useEffect(() => {
    dispatch(getProfileData()).then((res) => {
      const { vendorInfoId, isPayoutSetup } = res.payload.data;
      setPayoutData({
        ...payoutData,
        nameOnAccount: vendorInfoId?.payoutInfo?.nameOnAccount, //Name on bank account for vendor.
        bankAccountType: vendorInfoId?.payoutInfo?.bankAccountType, //CHECKING SAVINGS
        bankAccountClass: vendorInfoId?.payoutInfo?.bankAccountClass, // PERSONAL CORPORATE INTERNATIONAL
        bankName: vendorInfoId?.payoutInfo?.bankName,
        swiftBic: vendorInfoId?.payoutInfo?.swiftBic, // swiftBic
        iban: vendorInfoId?.payoutInfo?.iban, //iban
      });
      setShowPayout(isPayoutSetup);
    });
  }, []);

  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    
    // Clear error for this field when user starts typing
    if (fieldErrors[name]) {
      setFieldErrors({
        ...fieldErrors,
        [name]: false,
      });
    }
    
    if (name === "country") {
      const countryObj = bluesnapSupportedVendorCountries.find(
        (obj) => obj.Country === value
      );
      setPageContent({
        ...pageContent,
        country: countryObj?.Country,
        countryCode: countryObj?.Code,
      });
    } else {
      setPageContent({
        ...pageContent,
        [name]: value,
      });
    }
  };

  // Handle Account Details Update (without password)
  const EditInfo = async () => {
    const {
      firstname,
      lastname,
      email,
      dateOfBirth,
      address,
      city,
      country,
      state,
      postalCode,
      phone,
      currency,
      countryCode,
    } = pageContent;

    // Reset field errors
    setFieldErrors({});

    // Validate required fields
    const errors = {};
    if (!firstname || firstname.trim() === "") errors.firstname = true;
    if (!lastname || lastname.trim() === "") errors.lastname = true;
    if (!email || email.trim() === "") errors.email = true;
    if (!dateOfBirth) errors.dateOfBirth = true;
    if (!address || address.trim() === "") errors.address = true;
    if (!city || city.trim() === "") errors.city = true;
    if (!country || country.trim() === "") errors.country = true;
    if (!state || state.trim() === "") errors.state = true;
    if (!postalCode || postalCode.trim() === "") errors.postalCode = true;
    if (!currency || currency.trim() === "") errors.currency = true;
    if (!phone || phone.trim() === "") errors.phone = true;
    if (!countryCode || countryCode.trim() === "") errors.countryCode = true;

    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      toast.error(
        toastTranslation?.requried || "Kindly fill the required fields"
      );
      return;
    }

    // Update account details without password
    dispatch(createProfilePayout(pageContent)).then((response) => {
      if (!response.error) {
        dispatch(getProfileData());
        setPayoutData({
          ...payoutData,
          baseCurrency: currency,
          country: countryCode,
          state,
          address,
          zip: postalCode,
          city,
          iban: vendorInfoId?.payoutInfo?.iban,
        });
        setShowPayout(true);
        history.push("/customer-account/accountdetailsedit");
      }
    });
  };

  // Handle Password Change (independent function)
  const handlePasswordChange = async () => {
    const { password, confirmPassword, currentPassword } = pageContent;

    // Reset field errors
    setFieldErrors({});

    // Check if all password fields are empty
    if (
      password.trim() === "" &&
      confirmPassword.trim() === "" &&
      currentPassword.trim() === ""
    ) {
      toast.error(
        toastTranslation?.requried || "Please fill in the password fields"
      );
      setFieldErrors({
        currentPassword: true,
        password: true,
        confirmPassword: true,
      });
      return;
    }

    // Check if current password is provided
    if (currentPassword.trim() === "") {
      toast.error("Please enter your current password");
      setFieldErrors({ currentPassword: true });
      return;
    }

    // Check if new password and confirm password match
    if (password.trim() !== confirmPassword.trim()) {
      setFieldErrors({ password: true, confirmPassword: true });
      toast.error(
        toastTranslation?.error || "New Passwords do not match"
      );
      return;
    }

    // Check if new password is provided
    if (password.trim() === "" || confirmPassword.trim() === "") {
      toast.error("Please enter a new password");
      setFieldErrors({ password: true, confirmPassword: true });
      return;
    }

    // Validate and reset password
    dispatch(
      validatePassword({ password, confirmPassword, currentPassword })
    ).then(({ payload }) => {
      if (payload.success) {
        dispatch(ResetPassword({ password, token })).then(() => {
          // Clear password fields
          setPageContent({
            ...pageContent,
            currentPassword: "",
            password: "",
            confirmPassword: "",
          });
          history.push("/customer-account/account-details");
        });
      }
    });
  };

  const editPayoutData = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    // Clear error for this field when user starts typing
    if (payoutFieldErrors[name]) {
      setPayoutFieldErrors({
        ...payoutFieldErrors,
        [name]: false,
      });
    }

    setPayoutData({
      ...payoutData,
      [name]: value,
    });
  };

  const submitPayout = async () => {
    const {
      nameOnAccount,
      bankAccountType,
      bankAccountClass,
      bankName,
      swiftBic,
      iban,
    } = payoutData;

    // Reset payout field errors
    setPayoutFieldErrors({});

    // Validate payout required fields
    const errors = {};
    if (!nameOnAccount || nameOnAccount.trim() === "") errors.nameOnAccount = true;
    if (!bankAccountType || bankAccountType.trim() === "") errors.bankAccountType = true;
    if (!bankAccountClass || bankAccountClass.trim() === "") errors.bankAccountClass = true;
    if (!bankName || bankName.trim() === "") errors.bankName = true;
    if (!swiftBic || swiftBic.trim() === "") errors.swiftBic = true;
    if (!iban || iban.trim() === "") errors.iban = true;

    if (Object.keys(errors).length > 0) {
      setPayoutFieldErrors(errors);
      toast.error(
        toastTranslation?.requried || "Kindly fill the required fields"
      );
      return;
    }
    const finalDetails = {
      email,
      state,
      address,
      city,
      phone,
      firstName: firstname,
      lastName: lastname,
      country: countryCode,
      zip: postalCode,
      defaultPayoutCurrency: currency,
      vendorPrincipal: {
        email,
        city,
        address,
        firstName: firstname,
        lastName: lastname,
        country: countryCode, //country code
        zip: postalCode,
        dob: moment(dateOfBirth).format("DD-MM-YYYY"), // 28-09-9999
        personalIdentificationNumber: "1234",
      },
      vendorAgreement: {
        commissionPercent: 0,
        accountStatus: "ACTIVE",
        recurringCommission: "N",
      },
      payoutInfo: [{ ...payoutData }],
    };

    if (!vendorId) {
      dispatch(createPayoutMethod(finalDetails)).then(() => {
        dispatch(getProfileData());
      });
    } else {
      dispatch(updatePayoutMethod(finalDetails)).then(() => {
        dispatch(getProfileData());
      });
    }
  };

  return (
    <>
      <ToastContainer autoClose={20000} />
      <div className="main-row">
        <div className="row edit-form justify-content-center">
          {loading ? (
            <div>
              <i
                className="mx-auto fas fa-spinner fa-pulse fa-2x"
                style={{ color: "green" }}
              ></i>
            </div>
          ) : (
            <div className="col-md-12 ">
              {/* Account Details Section */}
              <Card className="mb-4">
                <CardHeader>
                  <h4 className="mb-0">
                    {shippingCartTranslation?.updateLine
                      ? shippingCartTranslation?.updateLine
                      : "Update your account Details"}
                  </h4>
                </CardHeader>
                <CardBody>
                  {typeof err !== "string" &&
                    err &&
                    err.length > 0 &&
                    err.map((e, index) => (
                      <li key={index} className="text-danger pl-3 mb-2">{e.description}</li>
                    ))}
                <div className="row">
                  <div className="col-6 mb-2">
                    <b>
                      <label>
                        {" "}
                        {shippingCartTranslation?.firsrtName
                          ? shippingCartTranslation?.firsrtName + " :"
                          : "First Name * "}
                      </label>
                    </b>
                    <Input
                      name="firstname"
                      value={pageContent?.firstname}
                      onChange={handleInputChange}
                      placeholder="First Name"
                      className="form-control"
                      invalid={fieldErrors.firstname}
                    />
                    {fieldErrors.firstname && (
                      <div className="text-danger small mt-1">This field is required</div>
                    )}
                  </div>
                  <div className="col-6 mb-2">
                    <b>
                      <label>
                        {" "}
                        {shippingCartTranslation?.lastName
                          ? shippingCartTranslation?.lastName + " :"
                          : "Last Name * "}
                      </label>
                    </b>
                    <Input
                      type="text"
                      placeholder="Last Name"
                      className="form-control"
                      value={pageContent?.lastname}
                      name="lastname"
                      onChange={handleInputChange}
                      invalid={fieldErrors.lastname}
                    />
                    {fieldErrors.lastname && (
                      <div className="text-danger small mt-1">This field is required</div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 mb-2">
                    <b>
                      <label>
                        {" "}
                        {sellerHomeTranslation?.email
                          ? sellerHomeTranslation?.email + " :"
                          : "Email Address *"}
                      </label>
                    </b>
                    <Input
                      type="email"
                      placeholder="Email"
                      className="form-control"
                      name="email"
                      disabled
                      value={pageContent?.email}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 mb-2">
                    <b>
                      <label htmlFor="dateOfBirth">
                        {sellerHomeTranslation?.dob
                          ? sellerHomeTranslation?.dob
                          : "Date of Birth *"}
                      </label>
                    </b>
                    <Input
                      className="form-control"
                      value={pageContent?.dateOfBirth}
                      onChange={handleInputChange}
                      type="date"
                      name="dateOfBirth"
                      id="dateOfBirth"
                      invalid={fieldErrors.dateOfBirth}
                    />
                    {fieldErrors.dateOfBirth && (
                      <div className="text-danger small mt-1">This field is required</div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 mb-2">
                    <b>
                      <label htmlFor="country">
                        {shippingCartTranslation?.country
                          ? shippingCartTranslation?.country
                          : "Country *"}
                      </label>
                    </b>
                    <Input
                      className="form-control"
                      value={pageContent?.country}
                      onChange={handleInputChange}
                      type="select"
                      name="country"
                      id="country"
                      invalid={fieldErrors.country}
                    >
                      <option value="">
                        {shippingCartTranslation?.select
                          ? shippingCartTranslation?.select +
                            shippingCartTranslation?.country
                          : "select Country *"}
                      </option>
                      {bluesnapSupportedVendorCountries?.map((obj, index) => (
                        <option key={index} value={obj?.Country}>
                          {obj.Country}
                        </option>
                      ))}
                    </Input>
                    {fieldErrors.country && (
                      <div className="text-danger small mt-1">This field is required</div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 mb-2">
                    <b>
                      <label htmlFor="currency">
                        {sellerHomeTranslation?.currency
                          ? sellerHomeTranslation?.currency
                          : "Currency *"}
                      </label>
                    </b>
                    <Input
                      className="form-control"
                      value={pageContent?.currency}
                      onChange={handleInputChange}
                      type="select"
                      name="currency"
                      id="currency"
                      invalid={fieldErrors.currency}
                    >
                      <option value="">
                        {" "}
                        {shippingCartTranslation?.select
                          ? shippingCartTranslation?.select +
                            sellerHomeTranslation?.currency
                          : "select currency*"}
                      </option>
                      {bluesnapSupportedVendorCurrencies?.map((obj, index) => (
                        <option key={index} value={obj?.currency}>
                          {obj.currency}
                        </option>
                      ))}
                    </Input>
                    {fieldErrors.currency && (
                      <div className="text-danger small mt-1">This field is required</div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 mb-2">
                    <b>
                      <label htmlFor="state">
                        {shippingCartTranslation?.state
                          ? shippingCartTranslation?.state
                          : "State/Province Code*"}
                      </label>
                    </b>
                    <Input
                      className="form-control"
                      value={pageContent?.state}
                      onChange={handleInputChange}
                      type="text"
                      name="state"
                      id="state"
                      placeholder={
                        shippingCartTranslation?.exampleState
                          ? shippingCartTranslation?.exampleState
                          : "e.g, CA"
                      }
                      invalid={fieldErrors.state}
                    />
                    {fieldErrors.state && (
                      <div className="text-danger small mt-1">This field is required</div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 mb-2">
                    <b>
                      <label htmlFor="city">
                        {shippingCartTranslation?.city
                          ? shippingCartTranslation?.city
                          : "city *"}
                      </label>
                    </b>
                    <Input
                      className="form-control"
                      value={pageContent?.city}
                      onChange={handleInputChange}
                      type="text"
                      name="city"
                      id="city"
                      placeholder={
                        shippingCartTranslation?.example
                          ? shippingCartTranslation?.example
                          : "e.g, Los Angeles"
                      }
                      invalid={fieldErrors.city}
                    />
                    {fieldErrors.city && (
                      <div className="text-danger small mt-1">This field is required</div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 mb-2">
                    <b>
                      <label htmlFor="address">
                        {sellerHomeTranslation?.address
                          ? sellerHomeTranslation?.address
                          : "Address Line 1 *"}
                      </label>
                    </b>
                    <Input
                      className="form-control"
                      value={pageContent?.address}
                      onChange={handleInputChange}
                      type="text"
                      name="address"
                      id="address"
                      placeholder={
                        shippingCartTranslation?.houseNo
                          ? shippingCartTranslation?.houseNo +
                            shippingCartTranslation?.street
                          : "House No , Street Name"
                      }
                      invalid={fieldErrors.address}
                    />
                    {fieldErrors.address && (
                      <div className="text-danger small mt-1">This field is required</div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 mb-2">
                    <b>
                      <label htmlFor="postalCode">
                        {sellerHomeTranslation?.postal
                          ? sellerHomeTranslation?.postal
                          : "Postal Code *"}
                      </label>
                    </b>
                    <Input
                      className="form-control"
                      value={pageContent?.postalCode}
                      onChange={handleInputChange}
                      type="text"
                      name="postalCode"
                      id="postalCode"
                      placeholder={
                        sellerHomeTranslation?.postal
                          ? sellerHomeTranslation?.postal
                          : "Postal Code"
                      }
                      invalid={fieldErrors.postalCode}
                    />
                    {fieldErrors.postalCode && (
                      <div className="text-danger small mt-1">This field is required</div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 mb-2">
                    <b>
                      <label htmlFor="phone">
                        {sellerHomeTranslation?.phone
                          ? sellerHomeTranslation?.phone
                          : "Phone No. *"}
                      </label>
                    </b>
                    <Input
                      className="form-control"
                      value={pageContent?.phone}
                      onChange={handleInputChange}
                      type="text"
                      name="phone"
                      id="phone"
                      placeholder={
                        sellerHomeTranslation?.phone
                          ? sellerHomeTranslation?.phone
                          : "Phone No"
                      }
                      invalid={fieldErrors.phone}
                    />
                    {fieldErrors.phone && (
                      <div className="text-danger small mt-1">This field is required</div>
                    )}
                  </div>
                </div>
                <div className="mt-3">
                  <Button
                    size="sm"
                    type="submit"
                    className="mx-1"
                    color="warning"
                    disabled={loading}
                    onClick={EditInfo}
                  >
                    {shippingCartTranslation?.saveButton
                      ? shippingCartTranslation?.saveButton
                      : "  Save changes"}
                  </Button>
                  <Button
                    size="sm"
                    color="danger"
                    disabled={loading}
                    onClick={() =>
                      history.push("/customer-account/account-details")
                    }
                  >
                    {userdashboardTranslation?.cancel
                      ? userdashboardTranslation?.cancel
                      : "cancel"}
                  </Button>
                </div>
                </CardBody>
              </Card>

              {/* Change Password Section */}
              <Card className="mb-4">
                <CardHeader>
                  <h4 className="mb-0">
                    {shippingCartTranslation?.password
                      ? shippingCartTranslation?.password
                      : "Password Change"}
                  </h4>
                </CardHeader>
                <CardBody>
                <div className="row">
                  <div className="col-12 mb-2">
                    <b>
                      <label>
                        {shippingCartTranslation?.currentPass
                          ? shippingCartTranslation?.currentPass
                          : "Current password "}
                        <span className="text-danger">*</span>
                      </label>
                    </b>
                    <Input
                      type="password"
                      name="currentPassword"
                      placeholder={
                        shippingCartTranslation?.currentPass
                          ? shippingCartTranslation?.currentPass
                          : "Current password "
                      }
                      className="form-control"
                      value={pageContent.currentPassword}
                      onChange={handleInputChange}
                      invalid={fieldErrors.currentPassword}
                    />
                    {fieldErrors.currentPassword && (
                      <div className="text-danger small mt-1">This field is required</div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 mb-2">
                    <b>
                      <label>
                        {shippingCartTranslation?.newPassword
                          ? shippingCartTranslation?.newPassword
                          : " New password  "}
                        <span className="text-danger">*</span>
                      </label>
                    </b>
                    <Input
                      type="password"
                      name="password"
                      placeholder={
                        shippingCartTranslation?.newPassword
                          ? shippingCartTranslation?.newPassword
                          : " new password  "
                      }
                      className="form-control"
                      value={pageContent.password}
                      onChange={handleInputChange}
                      invalid={fieldErrors.password}
                    />
                    {fieldErrors.password && (
                      <div className="text-danger small mt-1">Passwords do not match</div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 mb-2">
                    <b>
                      <label>
                        {shippingCartTranslation?.confirmPassword
                          ? shippingCartTranslation?.confirmPassword
                          : " Confirm new password "}
                        <span className="text-danger">*</span>
                      </label>
                    </b>
                    <Input
                      type="password"
                      name="confirmPassword"
                      placeholder={
                        shippingCartTranslation?.confirmPassword
                          ? shippingCartTranslation?.confirmPassword
                          : " password "
                      }
                      className="form-control"
                      value={pageContent.confirmPassword}
                      onChange={handleInputChange}
                      invalid={fieldErrors.confirmPassword}
                    />
                    {fieldErrors.confirmPassword && (
                      <div className="text-danger small mt-1">Passwords do not match</div>
                    )}
                  </div>
                </div>
                <div className="mt-3">
                  <Button
                    size="sm"
                    type="submit"
                    className="mx-1"
                    color="warning"
                    disabled={loading}
                    onClick={handlePasswordChange}
                  >
                    {shippingCartTranslation?.saveButton
                      ? shippingCartTranslation?.saveButton
                      : "  Change Password"}
                  </Button>
                </div>
                </CardBody>
              </Card>
              
              {(showPayout && !loading) && (
                <Card className="mb-4">
                  <CardHeader>
                    <h4 className="mb-0">
                      {userdashboardTranslation?.detailHeading
                        ? userdashboardTranslation?.detailHeading
                        : "Update Payout Details"}
                    </h4>
                  </CardHeader>
                  <CardBody>
                    <Form>
                      <FormGroup>
                        <Label for="state">
                          {userdashboardTranslation?.accountType
                            ? userdashboardTranslation?.accountType
                            : "Account Type *"}
                        </Label>
                        <Input
                          value={
                            userdashboardTranslation?.bankTransfer
                              ? userdashboardTranslation?.bankTransfer
                              : "Local Bank Transfer"
                          }
                          type="text"
                          name="type"
                          id="type"
                          placeholder={
                            userdashboardTranslation?.accountType
                              ? userdashboardTranslation?.accountType
                              : "Account Type "
                          }
                          disabled
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label for="nameOnAccount">
                          {userdashboardTranslation?.nameAccount
                            ? userdashboardTranslation?.nameAccount
                            : " Name on Bank Account  *"}
                        </Label>
                        <Input
                          value={payoutData?.nameOnAccount}
                          onChange={editPayoutData}
                          type="text"
                          name="nameOnAccount"
                          id="nameOnAccount"
                          placeholder={
                            userdashboardTranslation?.nameAccount
                              ? userdashboardTranslation?.nameAccount
                              : "Name on account"
                          }
                          invalid={payoutFieldErrors.nameOnAccount}
                        />
                        {payoutFieldErrors.nameOnAccount && (
                          <div className="text-danger small mt-1">This field is required</div>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for="bankName">
                          {userdashboardTranslation?.bankName
                            ? userdashboardTranslation?.bankName
                            : "Bank Name *"}
                        </Label>
                        <Input
                          value={payoutData?.bankName}
                          onChange={editPayoutData}
                          type="text"
                          name="bankName"
                          id="bankName"
                          placeholder={
                            userdashboardTranslation?.bankName
                              ? userdashboardTranslation?.bankName
                              : "Bank Name *"
                          }
                          invalid={payoutFieldErrors.bankName}
                        />
                        {payoutFieldErrors.bankName && (
                          <div className="text-danger small mt-1">This field is required</div>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for="swiftBic">
                          {userdashboardTranslation?.bic
                            ? userdashboardTranslation?.bic
                            : "swift Bic *"}
                        </Label>
                        <Input
                          value={payoutData?.swiftBic}
                          type="text"
                          onChange={editPayoutData}
                          name="swiftBic"
                          id="swiftBic"
                          placeholder={
                            userdashboardTranslation?.bic
                              ? userdashboardTranslation?.bic
                              : "swift Bic *"
                          }
                          invalid={payoutFieldErrors.swiftBic}
                        />
                        {payoutFieldErrors.swiftBic && (
                          <div className="text-danger small mt-1">This field is required</div>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for="iban">
                          {" "}
                          {userdashboardTranslation?.iban
                            ? userdashboardTranslation?.iban
                            : "Iban "}
                        </Label>
                        <Input
                          value={payoutData?.iban}
                          onChange={editPayoutData}
                          type="text"
                          name="iban"
                          id="iban"
                          placeholder={
                            userdashboardTranslation?.iban
                              ? userdashboardTranslation?.iban
                              : "Iban "
                          }
                          invalid={payoutFieldErrors.iban}
                        />
                        {payoutFieldErrors.iban && (
                          <div className="text-danger small mt-1">This field is required</div>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for="bankAccountType">
                          {userdashboardTranslation?.accountType
                            ? userdashboardTranslation?.accountType
                            : "Bank Account Type * "}
                        </Label>
                        <Input
                          value={payoutData?.bankAccountType}
                          onChange={editPayoutData}
                          type="select"
                          name="bankAccountType"
                          id="bankAccountType"
                          invalid={payoutFieldErrors.bankAccountType}
                        >
                          <option value="">
                            {userdashboardTranslation?.selectType
                              ? userdashboardTranslation?.selectType
                              : "select type "}
                          </option>
                          <option value={"CHECKING"}>CHECKING</option>
                          <option value={"SAVINGS"}>SAVINGS</option>
                        </Input>
                        {payoutFieldErrors.bankAccountType && (
                          <div className="text-danger small mt-1">This field is required</div>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label for="bankAccountClass">
                          {userdashboardTranslation?.accountClass
                            ? userdashboardTranslation?.accountClass
                            : "Bank Account Class * "}
                        </Label>
                        <Input
                          value={payoutData?.bankAccountClass}
                          onChange={editPayoutData}
                          type="select"
                          name="bankAccountClass"
                          id="bankAccountClass"
                          invalid={payoutFieldErrors.bankAccountClass}
                        >
                          <option value="">
                            {" "}
                            {userdashboardTranslation?.selectType
                              ? userdashboardTranslation?.selectType
                              : "select type "}
                          </option>
                          <option value={"PERSONAL"}>PERSONAL</option>
                          <option value={"CORPORATE"}>CORPORATE</option>
                          <option value={"INTERNATIONAL"}>INTERNATIONAL</option>
                        </Input>
                        {payoutFieldErrors.bankAccountClass && (
                          <div className="text-danger small mt-1">This field is required</div>
                        )}
                      </FormGroup>
                      <Button
                        size="sm"
                        color="warning"
                        disabled={loading}
                        onClick={submitPayout}
                      >
                        {userdashboardTranslation?.submitPayout
                          ? userdashboardTranslation?.submitPayout
                          : " Submit payout "}
                      </Button>
                    </Form>
                  </CardBody>
                </Card>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AccountDetailsEdit;
